var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import GridSection from '@marketing/components/sections/GridSection';
import useTicker from '@marketing/useTicker';
import { clsx } from 'clsx';
import Benefit from './Benefit';
function CareerBenefitsSection(_a) {
    var content = _a.content, _b = _a.theme, theme = _b === void 0 ? 'dark' : _b, _c = _a.backgroundColorStyle, backgroundColorStyle = _c === void 0 ? 'bg-surface-blue-dark' : _c;
    var tickerText = content.tickerText, benefits = content.benefits;
    var numCols = 3;
    return useTicker(_jsx(GridSection, __assign({ numCols: 3, backgroundColorStyle: backgroundColorStyle, className: "auto-rows-max md:auto-rows-fr", gapStyle: "gap-y-lg-gutter gap-x-xl-m", alignItemsStyle: "items-start", paddingStyle: "px-2xs-gutter py-sm-gutter md:px-3xl-gutter md:py-lg-gutter" }, { children: benefits.map(function (benefit, index) {
            var isOnlyBenefitOnRow = benefits.length % numCols === 1 && index === benefits.length - 1;
            return (_jsx("div", __assign({ className: clsx('w-full md:max-w-[300px]', isOnlyBenefitOnRow ? 'md:col-start-2 md:col-end-3' : '') }, { children: _jsx(Benefit, __assign({}, benefit, { theme: theme })) }), index));
        }) })), tickerText, backgroundColorStyle, theme);
}
export default CareerBenefitsSection;
